import React, { useState, useContext } from "react";
import { MyContext } from "./Context/MyContext";
import { ButtonGroup, IconButton } from "@mui/material";
import {
  DoneAll,
  ModeEdit,
  RestoreFromTrash,
  Delete,
} from "@mui/icons-material";

export const ToDoItem = ({ item }) => {
  const { updateItem, removeItem } = useContext(MyContext);
  const [edit, setEdit] = useState(false);
  const [text, setText] = useState(item.text);

  const handleTextChange = (e) => {
    setEdit(true);
    const textChanged = e.target.value ? e.target.value : text;
    setText(textChanged);
    const todos = JSON.parse(localStorage.getItem("todos"));
    const updatedTodos = todos.map((todo) => {
      if (todo.id === item.id) {
        todo.text = textChanged;
        return todo;
      } else return todo;
    });
    localStorage.setItem("todos", JSON.stringify(updatedTodos));
  };

  const handleTextChanged = (e) => {
    setEdit(false);
  };

  const handleKeyDown = (e) => {
    e.key === "Enter" && handleTextChanged();
  };

  return (
    <div className='ToDoItem'>
      {edit ? (
        <input
          autoFocus
          type='text'
          value={text}
          onKeyDown={handleKeyDown}
          onChange={handleTextChange}
        />
      ) : (
        <>
          <p className='ToDoItem-title'>{text}</p>
        </>
      )}
      <ButtonGroup>
        {!item.done && (
          <IconButton
            color='secondary'
            onClick={
              !edit ? () => handleTextChange() : () => handleTextChanged()
            }
          >
            <ModeEdit fontSize='small' />
          </IconButton>
        )}
        {item.done ? (
          <IconButton color='secondary' onClick={() => updateItem(item.id)}>
            <RestoreFromTrash fontSize='small' />
          </IconButton>
        ) : (
          <IconButton color='success' onClick={() => updateItem(item.id)}>
            <DoneAll fontSize='small' />
          </IconButton>
        )}
        {item.done && (
          <IconButton color='error' onClick={() => removeItem(item.id)}>
            <Delete fontSize='small' />
          </IconButton>
        )}
      </ButtonGroup>
    </div>
  );
};
